import { Sparkles, Leaf, PackageCheck, Ship } from "lucide-react";
import { Reveal, GoldDivider } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

const ICON_LIST = [Sparkles, Leaf, PackageCheck, Ship];

const Features = () => {
  const { t } = useLang();
  return (
    <section data-testid="features-section" className="bg-cream pb-24 md:pb-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="text-center">
          <p className="overline text-gold">{t.features.overline}</p>
          <h2 className="mt-2 font-serif font-light text-ink text-4xl md:text-5xl">
            {t.features.title}
          </h2>
          <GoldDivider />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 border-t border-gold/25 sm:grid-cols-2 lg:grid-cols-4">
          {t.features.items.map((f, i) => {
            const Icon = ICON_LIST[i];
            return (
              <Reveal
                key={i}
                delay={i * 0.1}
                className="group border-b border-gold/25 px-8 py-12 sm:border-r sm:[&:nth-child(2n)]:border-r-0 lg:[&:nth-child(2n)]:border-r lg:[&:nth-child(4n)]:border-r-0"
              >
                <div data-testid={`feature-${i}`} className="flex flex-col">
                  <Icon
                    className="h-9 w-9 text-gold transition-transform duration-500 group-hover:-translate-y-1"
                    strokeWidth={1.25}
                  />
                  <h3 className="mt-6 font-serif text-2xl text-ink">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-clay">{f.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
